// @flow

import SuggestionsBuilder from './SuggestionsBuilder';
import ContentSuggestionTypes from '../../../constants/search/ContentSuggestionTypes';
import Collection from '../../Collection';

export default class ContentSuggestions extends SuggestionsBuilder {
  title: string;
  baseUrl: string = '';

  /**
   *
   */
  constructor(suggestions: Array<any>, type: string, dataLayerSuggestions: Collection<Object>) {
    super(suggestions, dataLayerSuggestions);
    this.title = window.store.getTranslation(`suggestions.${type}.title`);

    if (type === ContentSuggestionTypes.CUSTOMER_SERVICE) {
      this.baseUrl = `/${window.store.getTranslation('customer-service.path')}`;
    }
  }

  /**
   * @inheritDoc
   */
  template(): string {
    const eventData: string = encodeURIComponent(JSON.stringify({ content: this.dataLayerSuggestions.all() }));
    const on = encodeURIComponent(JSON.stringify({ view: 'content-impression' }));
    return `
      <span class="block text-xs text-grey px-4 mt-4 mb-2">
        ${this.title}
      </span>
      <ul class="mb-0 ml-0">
        ${this.buildSuggestions()}
      </ul>
    `;
  }

  /**
   * @inheritDoc
   */
  suggestion(suggestion: any): string {
    const eventData: string = this.dataLayerSuggestions
      .find((datalayerSuggestion: Object) => datalayerSuggestion.name === suggestion.name);
    const on = encodeURIComponent(JSON.stringify({ click: 'content-click' }));
    return `
      <li>
        <a
          href="${this.baseUrl}/${suggestion.slug}"
          class="block px-4 py-2 text-black hover:bg-light-grey focus:bg-light-grey"
          ref="suggestion"
        >
          ${suggestion.name}
        </a>
      </li>
    `;
  }

  /**
   * @inheritDoc
   */
  static hasValidData(data: any): boolean {
    return Object.prototype.hasOwnProperty.call(data, 'type') &&
      Object.prototype.hasOwnProperty.call(data, 'items') &&
      Array.isArray(data.items) &&
      data.items.length;
  }
}
